import z from 'zod'

export const QrCodeOption = z.object({
    archiveDepth: z.number(),
    email: z.string(),
    objectId: z.string().nullable().optional(),
    prevQrCodeId: z.string().optional(),
})

export const QrCodeParamsSchema = z.object({
    type: z.number(),
    workspaceId: z.number(),
    userId: z.number(),
    qrcodeOptions: QrCodeOption,
    dataEnrichmentOptions: z
        .object({
            enrichmentRulesGroups: z.array(z.string()).default(['basic']),
        })
        .optional(),
})

export const QrCodeResponseSchema = z.object({
    status: z.string(),
    error: z.string().nullable(),
    result: z
        .object({
            integrationId: z.number(),
            topicId: z.number().nullable(),
            workspaceId: z.number().optional(),
        })
        .nullable(),
    qrCode: z
        .object({
            id: z.string(),
            data: z.string().optional().nullable(),
        })
        .nullable(),
    objectId: z.string().optional(),
})

export type QrCodeParams = z.infer<typeof QrCodeParamsSchema>
export type QrCodeResponse = z.infer<typeof QrCodeResponseSchema>
